import React from 'react'

/**
 * @deprecated key-* components are no longer supported.
 */
export const KeyLabel = (props) => {
  const { className, ...labelProps } = props

  return (
    <label
      {...labelProps}
      className={`block text-[11px] text-gray-400 ${className}`}
    >
      {props.children}
    </label>
  )
}
